<form
  class="registration-form"
  [formGroup]="todoFormulario"
  (ngSubmit)="continuar()"
  novalidate>

  <div class="registration-profile">
    <span>Perfil: </span>
    <strong>{{ configuracionRegistro().perfilNombre }}</strong>
  </div>

  <section class="registration-alert">
    <span class="registration-alert__icon">
      <mat-icon>verified_user</mat-icon>
    </span>

    <div>
      <h2>Verificamos tu identidad para proteger tu cuenta</h2>
      <p>Tus datos están seguros con nosotros.</p>
    </div>
  </section>

  <section class="registration-section">
    <header class="registration-section__header">
      <mat-icon>lock</mat-icon>
      <h3>Datos de acceso</h3>
    </header>

    <div class="registration-fields-card">
      <div
        class="registration-field registration-field--with-field-error"
        [class.registration-field--invalid]="isInvalid('Cuenta')">

        <label for="registration-cuenta">
          {{ configuracionRegistro().etiquetaCuenta }}*
        </label>

        <input
          id="registration-cuenta"
          name="atlas-reg-profile-key"
          type="text"
          formControlName="Cuenta"
          [placeholder]="configuracionRegistro().placeholderCuenta"
          [attr.inputmode]="configuracionRegistro().cuentaSoloNumerica ? 'numeric' : 'text'"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false">

        @if (isInvalid('Cuenta')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            [attr.aria-label]="'Ver detalle de ' + configuracionRegistro().etiquetaCuenta"
            (click)="abrirErrorCampo('Cuenta')">
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid('Cuenta')) {
          <small>{{ getError('Cuenta') }}</small>
        }
      </div>

      <div
        class="registration-field registration-field--with-field-error"
        [class.registration-field--invalid]="isInvalid('NIP')">

        <label for="registration-nip">NIP*</label>

        <input
          id="registration-nip"
          name="atlas-reg-nip"
          type="tel"
          formControlName="NIP"
          placeholder="Ingresa tu NIP"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false">

        @if (isInvalid('NIP')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            aria-label="Ver detalle de NIP"
            (click)="abrirErrorCampo('NIP')">
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid('NIP')) {
          <small>{{ getError('NIP') }}</small>
        }
      </div>

      <div
        class="registration-field registration-field--with-status"
        [class.registration-field--invalid]="isInvalid('Usuario')">

        <label for="registration-usuario">Usuario*</label>

        <input
          id="registration-usuario"
          name="atlas-reg-user-key"
          type="text"
          formControlName="Usuario"
          placeholder="Ingresa tu usuario"
          minlength="4"
          maxlength="8"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false">

        <span class="registration-field__status">
          @if (usuarioValido.pending) {
            <mat-icon
              class="registration-field__status-icon registration-field__status-icon--pending">
              sync
            </mat-icon>
          }

          @if (
            usuarioValido.is
            && !usuarioValido.pending
            && todoFormulario.controls.Usuario.valid
          ) {
            <mat-icon
              class="registration-field__status-icon registration-field__status-icon--success">
              check_circle
            </mat-icon>
          }

          @if (
            isInvalid('Usuario')
            && !usuarioValido.pending
            && !usuarioValido.is
          ) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--status registration-field__alert-button--error"
              aria-label="Ver detalle del usuario"
              (click)="abrirInfoUsuario()">
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid('Usuario')) {
          <small>{{ getError('Usuario') }}</small>
        }
      </div>

      <div
        class="registration-field registration-field--with-action registration-field--alias"
        [class.registration-field--invalid]="isInvalid('Alias')">

        <label for="registration-alias">Alias o sobrenombre*</label>

        <input
          id="registration-alias"
          name="atlas-reg-alias-ref"
          type="text"
          formControlName="Alias"
          placeholder="Ingresa tu alias"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false">

        @if (isInvalid('Alias')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            aria-label="Ver detalle del alias"
            (click)="abrirErrorCampo('Alias')">
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (!isInvalid('Alias')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--info"
            aria-label="Información sobre alias"
            (click)="abrirInfoAlias()">
            <mat-icon>info_outline</mat-icon>
          </button>
        }

        @if (isInvalid('Alias')) {
          <small>{{ getError('Alias') }}</small>
        }
      </div>

      <div
        class="registration-field registration-field--with-action registration-field--password"
        [class.registration-field--invalid]="isInvalid('Password')">

        <label for="registration-password">Contraseña*</label>

        <input
          id="registration-password"
          name="atlas-reg-access-pass"
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="Password"
          placeholder="Ingresa tu contraseña"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          readonly
          (focus)="desbloquearAutofill($event)"
          (blur)="bloquearAutofill($event)"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other">

        <div class="registration-field__actions">
          <button
            type="button"
            class="registration-field__icon-button"
            (click)="hidePassword = !hidePassword"
            aria-label="Mostrar u ocultar contraseña">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          @if (mostrarIconoPasswordCorrecto()) {
            <mat-icon class="registration-field__success-icon">
              check_circle
            </mat-icon>
          }

          @if (isInvalid('Password')) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--error"
              aria-label="Ver detalle de contraseña"
              (click)="abrirErrorPassword()">
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </div>

        @if (isInvalid('Password')) {
          <small>{{ getError('Password') }}</small>
        }
      </div>

      <div
        class="registration-field registration-field--with-action registration-field--password"
        [class.registration-field--invalid]="isInvalid('ConfirmaPassword')">

        <label for="registration-confirma-password">Confirma contraseña*</label>

        <input
          id="registration-confirma-password"
          name="atlas-reg-access-pass-confirm"
          [type]="hideConfirmPassword ? 'password' : 'text'"
          formControlName="ConfirmaPassword"
          placeholder="Confirma tu contraseña"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          readonly
          (focus)="desbloquearAutofill($event)"
          (blur)="bloquearAutofill($event)"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other">

        <div class="registration-field__actions">
          <button
            type="button"
            class="registration-field__icon-button"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            aria-label="Mostrar u ocultar confirmación de contraseña">
            <mat-icon>
              {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>

          @if (mostrarIconoConfirmaPasswordCorrecto()) {
            <mat-icon class="registration-field__success-icon">
              check_circle
            </mat-icon>
          }

          @if (isInvalid('ConfirmaPassword')) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--error"
              aria-label="Ver detalle de confirmación de contraseña"
              (click)="abrirErrorCampo('ConfirmaPassword')">
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </div>

        @if (isInvalid('ConfirmaPassword')) {
          <small>{{ getError('ConfirmaPassword') }}</small>
        }
      </div>
    </div>
  </section>

  <section class="registration-section">
    <header class="registration-section__header">
      <mat-icon>verified_user</mat-icon>
      <h3>Verificación de contacto</h3>
    </header>

    <div
      class="registration-contact-card"
      [class.registration-contact-card--email-full]="!dosFaCorreoHabilitado"
      [class.registration-contact-card--phone-full]="!dosFaTelefonoHabilitado">
      <div
        class="registration-field registration-field--with-field-error"
        [class.registration-field--invalid]="isInvalid('Email') || mostrarErrorUsuarioContacto('Email')">

        <label for="registration-email">Email*</label>

        <input
          id="registration-email"
          name="atlas-reg-contact-mail"
          type="text"
          inputmode="email"
          formControlName="Email"
          placeholder="correo@ejemplo.com"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          readonly
          (focus)="desbloquearAutofill($event)"
          (blur)="bloquearAutofill($event); verificarCorreoAlPerderFoco()"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other">

        @if (isInvalid('Email')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            aria-label="Ver detalle del correo electrónico"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Email')">
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (
          todoFormulario.get('Email')?.value &&
          todoFormulario.get('Email')?.valid &&
          !mostrarErrorUsuarioContacto('Email')
        ) {
          <span
            class="registration-field__status"
            role="status"
            aria-label="Correo electrónico válido">
            <mat-icon class="registration-field__status-icon registration-field__status-icon--success">
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid('Email')) {
          <small>{{ getError('Email') }}</small>
        }

        @if (mostrarErrorUsuarioContacto('Email')) {
          <small class="registration-field__dependency-error">
            {{ getErrorUsuarioContacto('Email') }}
          </small>
        }
      </div>

      <button
        type="button"
        class="registration-verify-button"
        [class.registration-verify-button--hidden]="!dosFaCorreoHabilitado"
        [class.registration-verify-button--ok]="validandoCorreo"
        [disabled]="consultandoNormaCorreo || validandoCorreo || !todoFormulario.controls.Email.valid || procesandoCorreo"
        (click)="verificarCorreo()">

        <mat-icon [class.registration-verify-button__icon--spin]="consultandoNormaCorreo || procesandoCorreo">
          {{ validandoCorreo ? 'check_circle' : (consultandoNormaCorreo || procesandoCorreo) ? 'sync' : 'mail' }}
        </mat-icon>

        <span>
          {{ validandoCorreo ? 'Verificado' : consultandoNormaCorreo ? 'Consultando' : procesandoCorreo ? 'Enviando' : 'Click para verificar' }}
        </span>
      </button>

      <div
        class="registration-field registration-field--phone registration-field--with-field-error"
        [class.registration-field--invalid]="isInvalid('Telefono') || mostrarErrorUsuarioContacto('Telefono')">

        <label for="registration-telefono">Teléfono celular*</label>

        <div class="registration-phone-control">
          <div class="registration-select registration-select--compact registration-phone-control__select-wrapper">
            <select
              class="registration-select__control registration-select__control--country registration-phone-control__select"
              name="atlas-reg-phone-country"
              [value]="codigoPaisTelefonoSeleccionadoKey"
              autocomplete="off"
              (change)="seleccionarCodigoPaisTelefono($event)">

              @for (pais of codigosPaisTelefono; track getCodigoPaisTelefonoKey(pais)) {
                <option
                  [value]="getCodigoPaisTelefonoKey(pais)"
                  [selected]="getCodigoPaisTelefonoKey(pais) === codigoPaisTelefonoSeleccionadoKey">
                  {{ pais.pais }} +{{ pais.codigo }}
                </option>
              }
            </select>

            <mat-icon class="registration-select__chevron registration-phone-control__chevron">
              keyboard_arrow_down
            </mat-icon>
          </div>

          <input
            id="registration-telefono"
            name="atlas-reg-contact-phone-local"
            type="text"
            inputmode="numeric"
            [value]="telefonoLocal"
            maxlength="10"
            placeholder="10 dígitos"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (input)="capturarTelefonoLocal($event)"
            (blur)="bloquearAutofill($event); verificarTelefonoAlPerderFoco()"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other">
        </div>

        @if (isInvalid('Telefono')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            aria-label="Ver detalle del teléfono celular"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Telefono')">
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (
          telefonoTieneFormatoCorrecto() &&
          !mostrarErrorUsuarioContacto('Telefono')
        ) {
          <span
            class="registration-field__status"
            role="status"
            aria-label="Teléfono celular válido">
            <mat-icon class="registration-field__status-icon registration-field__status-icon--success">
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid('Telefono')) {
          <small>{{ getError('Telefono') }}</small>
        }

        @if (mostrarErrorUsuarioContacto('Telefono')) {
          <small class="registration-field__dependency-error">
            {{ getErrorUsuarioContacto('Telefono') }}
          </small>
        }
      </div>

      <button
        type="button"
        class="registration-verify-button"
        [class.registration-verify-button--hidden]="!dosFaTelefonoHabilitado"
        [class.registration-verify-button--ok]="validandoTelefono"
        [disabled]="consultandoNormaTelefono || !telefonoPuedeVerificarse()"
        (click)="verificarTelefono()">

        <mat-icon [class.registration-verify-button__icon--spin]="consultandoNormaTelefono || procesandoTelefono">
          {{ validandoTelefono ? 'check_circle' : (consultandoNormaTelefono || procesandoTelefono) ? 'sync' : 'phone_iphone' }}
        </mat-icon>

        <span>
          {{ validandoTelefono ? 'Verificado' : consultandoNormaTelefono ? 'Consultando' : procesandoTelefono ? 'Enviando' : 'Click para verificar' }}
        </span>
      </button>
    </div>
  </section>

  <section class="registration-section">
    <header class="registration-section__header">
      <mat-icon>vpn_key</mat-icon>
      <h3>Pregunta de seguridad</h3>
    </header>

    <div class="registration-fields-card">
      <div
        class="registration-field registration-field--select"
        [class.registration-field--invalid]="isInvalid('IdPregunta')">

        <label for="registration-pregunta">Pregunta secreta*</label>

        <div class="registration-select">
          <select
            id="registration-pregunta"
            class="registration-select__control registration-select__control--question"
            name="atlas-reg-secret-question"
            formControlName="IdPregunta"
            autocomplete="off">

            <option [ngValue]="null">Selecciona una pregunta</option>

            @for (pregunta of catPreguntas; track pregunta.Value) {
              <option [ngValue]="pregunta.Value">
                {{ pregunta.Text }}
              </option>
            }
          </select>

          <mat-icon class="registration-select__chevron">
            keyboard_arrow_down
          </mat-icon>
        </div>

        @if (isInvalid('IdPregunta')) {
          <small>{{ getError('IdPregunta') }}</small>
        }
      </div>

      <div
        class="registration-field registration-field--with-field-error"
        [class.registration-field--invalid]="isInvalid('Respuesta')">

        <label for="registration-respuesta">Respuesta*</label>

        <input
          id="registration-respuesta"
          name="atlas-reg-secret-answer"
          type="text"
          formControlName="Respuesta"
          placeholder="Escribe tu respuesta"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false">

        @if (isInvalid('Respuesta')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            aria-label="Ver detalle de respuesta"
            (click)="abrirErrorCampo('Respuesta')">
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid('Respuesta')) {
          <small>{{ getError('Respuesta') }}</small>
        }
      </div>
    </div>
  </section>

  <section class="registration-section">
    <header class="registration-section__header">
      <mat-icon>person</mat-icon>
      <h3>Datos personales y fiscales</h3>
    </header>

    <div class="registration-fields-card">
      <div
        class="registration-field registration-field--select registration-field--full"
        [class.registration-field--invalid]="isInvalid('TipoPersona')">

        <label for="registration-tipo-persona">Tipo de persona*</label>

        <div class="registration-select">
          <select
            id="registration-tipo-persona"
            class="registration-select__control"
            name="atlas-reg-person-type"
            formControlName="TipoPersona"
            autocomplete="off">

            @for (persona of tiposPersona; track persona.Value) {
              <option [ngValue]="persona.Value">
                {{ persona.Text }}
              </option>
            }
          </select>

          <mat-icon class="registration-select__chevron">
            keyboard_arrow_down
          </mat-icon>
        </div>

        @if (isInvalid('TipoPersona')) {
          <small>{{ getError('TipoPersona') }}</small>
        }
      </div>

      @if (todoFormulario.controls.TipoPersona.value === 1) {
        <div
          class="registration-field registration-field--with-field-error"
          [class.registration-field--invalid]="isInvalid('Nombre')">

          <label for="registration-nombre">Nombre*</label>

          <input
            id="registration-nombre"
            name="atlas-reg-person-name"
            type="text"
            formControlName="Nombre"
            placeholder="Ingresa tu nombre"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (blur)="bloquearAutofill($event)"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other">

          @if (isInvalid('Nombre')) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
              aria-label="Ver detalle de nombre"
              (click)="abrirErrorCampo('Nombre')">
              <mat-icon>error_outline</mat-icon>
            </button>
          }

          @if (isInvalid('Nombre')) {
            <small>{{ getError('Nombre') }}</small>
          }
        </div>

        <div
          class="registration-field registration-field--with-field-error"
          [class.registration-field--invalid]="isInvalid('Paterno')">

          <label for="registration-paterno">Apellido paterno*</label>

          <input
            id="registration-paterno"
            name="atlas-reg-person-lastname"
            type="text"
            formControlName="Paterno"
            placeholder="Ingresa tu apellido paterno"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (blur)="bloquearAutofill($event)"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other">

          @if (isInvalid('Paterno')) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
              aria-label="Ver detalle de apellido paterno"
              (click)="abrirErrorCampo('Paterno')">
              <mat-icon>error_outline</mat-icon>
            </button>
          }

          @if (isInvalid('Paterno')) {
            <small>{{ getError('Paterno') }}</small>
          }
        </div>

        <div
          class="registration-field registration-field--with-field-error"
          [class.registration-field--invalid]="isInvalid('Materno')">

          <label for="registration-materno">Apellido materno*</label>

          <input
            id="registration-materno"
            name="atlas-reg-person-second-lastname"
            type="text"
            formControlName="Materno"
            placeholder="Ingresa tu apellido materno"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (blur)="bloquearAutofill($event)"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other">

          @if (isInvalid('Materno')) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
              aria-label="Ver detalle de apellido materno"
              (click)="abrirErrorCampo('Materno')">
              <mat-icon>error_outline</mat-icon>
            </button>
          }

          @if (isInvalid('Materno')) {
            <small>{{ getError('Materno') }}</small>
          }
        </div>
      }

      @if (todoFormulario.controls.TipoPersona.value === 2) {
        <div
          class="registration-field registration-field--with-field-error"
          [class.registration-field--invalid]="isInvalid('RazonSocial')">

          <label for="registration-razon-social">Razón social*</label>

          <input
            id="registration-razon-social"
            name="atlas-reg-business-name"
            type="text"
            formControlName="RazonSocial"
            placeholder="Ingresa la razón social"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (blur)="bloquearAutofill($event)"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other">

          @if (isInvalid('RazonSocial')) {
            <button
              type="button"
              class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
              aria-label="Ver detalle de razón social"
              (click)="abrirErrorCampo('RazonSocial')">
              <mat-icon>error_outline</mat-icon>
            </button>
          }

          @if (isInvalid('RazonSocial')) {
            <small>{{ getError('RazonSocial') }}</small>
          }
        </div>
      }

      <div
        class="registration-field registration-field--with-field-error"
        [class.registration-field--invalid]="isInvalid('RFC')">

        <label for="registration-rfc">RFC*</label>

        <input
          id="registration-rfc"
          name="atlas-reg-tax-ref"
          type="text"
          formControlName="RFC"
          placeholder="Ingresa tu RFC"
          maxlength="13"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          readonly
          (focus)="desbloquearAutofill($event)"
          (blur)="bloquearAutofill($event)"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other">

        @if (isInvalid('RFC')) {
          <button
            type="button"
            class="registration-field__alert-button registration-field__alert-button--field registration-field__alert-button--error"
            aria-label="Ver detalle de RFC"
            (click)="abrirErrorCampo('RFC')">
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid('RFC')) {
          <small>{{ getError('RFC') }}</small>
        }
      </div>
    </div>
  </section>

  <div class="registration-actions">
    <button
      type="button"
      class="registration-button registration-button--secondary"
      (click)="regresar()">
      Regresar
    </button>

    <button
      type="submit"
      class="registration-button registration-button--primary"
      [disabled]="loadingRegistro">
      {{ loadingRegistro ? 'Registrando...' : 'Continuar' }}
    </button>
  </div>
</form>
